const UNSET_VALUE = '-';
const INDEX_NOT_FOUND = -1;

const normalizeSelectValue = (value: string | undefined, defaultValue: string): string =>
  value && value !== UNSET_VALUE ? value : defaultValue;

const findIdByName = (
  array: { id: number; name: string }[],
  value: string,
): number | undefined => array.find(item => item.name === value)?.id;

const findIndexById = (
  array: { id: number }[],
  item: { id: number } | undefined,
): number =>
  item ? array.findIndex(arrayItem => arrayItem.id === item.id) : INDEX_NOT_FOUND;

export { normalizeSelectValue, findIdByName, findIndexById };
